import { render, staticRenderFns } from "./LbaWindow.vue?vue&type=template&id=564c8198"
import script from "./LbaWindow.vue?vue&type=script&lang=js"
export * from "./LbaWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports